import PaymentSuccessModal from './PaymentSuccessModal.vue';
import { createModal } from '@lingtu/components';

export function openPaymentSuccessModal(params = {}) {
  return createModal({
    params,
    component: PaymentSuccessModal,
  });
}
